import { useSyncExternalStore } from "react"

const MOBILE_BREAKPOINT = 768

// Lazy-initialize media query list (SSR-safe)
let mql: MediaQueryList | null = null
function getMediaQueryList(): MediaQueryList | null {
  if (typeof window === "undefined") return null
  mql ??= window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
  return mql
}

function mediaQueryListener(callback: (event: MediaQueryListEvent) => void) {
  const mediaQuery = getMediaQueryList()
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  if (!mediaQuery) return () => {}

  mediaQuery.addEventListener("change", callback)
  return () => {
    mediaQuery.removeEventListener("change", callback)
  }
}

function isSmallerThanBreakpoint() {
  const mediaQuery = getMediaQueryList()
  return mediaQuery?.matches ?? false
}

// SSR returns false (desktop), client will re-render if needed
function getServerSnapshot() {
  return false
}

export function useIsMobile() {
  return useSyncExternalStore(
    mediaQueryListener,
    isSmallerThanBreakpoint,
    getServerSnapshot,
  )
}
